var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle",class:{
    blue: _vm.blue,
    independence: _vm.independence,
    khaki: _vm.khaki,
    pink: _vm.pink,
    geranium: _vm.geranium,
  },style:({
    height: _vm.size + 'px',
    width: _vm.size + 'px',
  }),attrs:{"align":"center"},on:{"click":_vm.click}},[_c('span',{staticClass:"text_circle",style:({
      lineHeight: _vm.size + 'px',
    })},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }